import Marquee from "react-fast-marquee";

const items = [
    "Railway Civil Works",
    "Track Laying",
    "Infrastructure",
    "Bridges & RUBs",
    "Earthwork",
    "Engineering Excellence",
];

export default function Ribbon() {
    return (
        <section data-testid="marquee-ribbon" className="border-y border-navy-deep bg-navy py-5">
            <Marquee speed={38} gradient={false} direction="left" pauseOnHover>
                <div className="flex items-center">
                    {items.map((item, i) => (
                        <div key={i} className="flex items-center">
                            <span className="whitespace-nowrap px-8 font-display text-2xl font-medium uppercase tracking-mega text-white md:text-3xl">
                                {item}
                            </span>
                            <span className="h-2.5 w-2.5 rotate-45 bg-orange" />
                        </div>
                    ))}
                </div>
            </Marquee>
        </section>
    );
}
